import React from "react";
import {Col, Row} from "react-bootstrap";
import {ButtonComponent, InputComponent} from "@Components/Forms";
import {NavLink} from "react-router-dom";

import {
    Navigate
} from "react-router-dom";
import iconHome from "@Icons/SVG/icon-home-s-grey.svg";
import iconNotifications from "@Icons/SVG/icon-notifications-s-grey.svg";
import iconUserProfile from "@Icons/SVG/icon-user_profile-s-grey.svg";
import iconSearch from "@Icons/SVG/icon-search-s-grey.svg";


import "./index.scss";
import {UseUserSignInAction, UseUserSignOutAction} from "@Store/@Hooks/@@Actions";
import {UseQyvoUser} from "@Store/@Hooks";

export const ApplicationHeaderUserZoneComponent:React.FC = () => {

    const UserSignOutAction = UseUserSignOutAction();

    const QyvoUser = UseQyvoUser();


    const [searchClaimsValue, setSearchClaimsValue] = React.useState("");

    const changeSearchClaimsValue = (e:React.ChangeEvent<HTMLInputElement>) => {
        const searchValue = e.target.value;
        setSearchClaimsValue(searchValue);
    };

    return (
        <Col xs={12} lg={8} className={'app-header-user-zone'}>
            <Row className={'app-header-user-zone__content'}>

                {/*<Col xs={12} lg={'auto'} className={'app-header-user-zone__search-claims'}>*/}
                {/*    <Row className={'app-header-user-zone__search-claims__content'}>*/}
                {/*        <InputComponent*/}
                {/*            value={searchClaimsValue}*/}
                {/*            setValue={e => changeSearchClaimsValue(e)}*/}
                {/*            placeholder={'Search claims...'}*/}
                {/*        />*/}
                {/*    </Row>*/}
                {/*</Col>*/}

                <Col xs={12} lg={'auto'} className={'app-header-user-zone__user-menu'}>
                    <Row>
                        <Col xs={'auto'} className={'app-header-user-zone__user-menu__link-element'}>
                            <ButtonComponent
                                text={'Dashboard'}
                                type={'flat'} size={'l'}
                                href={'/dashboard'}
                            />
                        </Col>
                        {/*<Col xs={'auto'} className={'app-header-user-zone__user-menu__link-element'}>*/}
                        {/*    <ButtonComponent*/}
                        {/*        text={'Notifications'}*/}
                        {/*        type={'flat'}*/}
                        {/*        iconLeft={iconNotifications}*/}
                        {/*        buttonDisabled={true}*/}
                        {/*    />*/}
                        {/*</Col>*/}
                        <Col xs={'auto'} className={'app-header-user-zone__user-menu__link-element'}>
                            {QyvoUser?.qyvoUserProfilePicture && <img src={`https://qyvo-engine.webpros.pl/${QyvoUser?.qyvoUserProfilePicture}`} />}
                            <ButtonComponent
                                text={QyvoUser ? `${QyvoUser.qyvoUserFirstName}`: 'Qyvo User'}
                                type={'flat'} size={'l'}
                                href={'/dashboard/wallet'}
                                iconLeft={QyvoUser?.qyvoUserProfilePicture ? '' : iconUserProfile}
                            />
                        </Col>
                        {/*<Col xs={'auto'} className={'app-header-user-zone__user-menu__link-element'}>*/}
                        {/*    <ButtonComponent*/}
                        {/*        text={'Sign Out'}*/}
                        {/*        type={'flat'}*/}
                        {/*        callback={() => UserSignOutAction()}*/}
                        {/*    />*/}
                        {/*</Col>*/}
                    </Row>
                </Col>

            </Row>
        </Col>
    );

};


export default ApplicationHeaderUserZoneComponent;
